<template>
    <div class="hidden sm:flex sticky top-0 bg-white shadow-md px-4 py-5 h-screen">
        <div class="flex flex-col justify-between h-full">
            <RouterLink to="/dashboard" class="h-12 w-12 mx-auto">
                <LogoImage/>
            </RouterLink>

            <ul class="flex flex-col space-y-8 mx-auto">
                <MenuIconItem v-if="user" icon="house" to="/dashboard" :help-text="trans('menu.dashboard')"/>

                <MenuIconItem v-if="user" icon="qrcode" to="/create/product" :help-text="trans('menu.create-qr-code')"/>

                <MenuIconItem v-if="user" icon="user-gear" to="/user" :help-text="trans('menu.user')"/>

                <Tooltip placement="right" :distance="15" :delay="20" theme="menu-tooltip">
                    <Language class="mx-auto" icon-only/>

                    <template #popper>
                        {{ trans('menu.change-language') }}
                    </template>
                </Tooltip>
            </ul>

            <div class="flex mx-auto justify-end">
                <Tooltip v-if="user" placement="right" :distance="15" :delay="20" theme="menu-tooltip">
                    <button @click="userStore.logout" class="block hover:text-brand text-slate-700">
                        <QrIcon icon="left-from-bracket" class="h-7"/>
                    </button>
                    <template #popper>
                        {{ trans('menu.logout') }}
                    </template>
                </Tooltip>
                <Tooltip v-else placement="right" :distance="15" :delay="20" theme="menu-tooltip">
                    <RouterLink to="/login" class="block hover:text-brand text-slate-700">
                        <QrIcon icon="right-from-bracket" class="h-7"/>
                    </RouterLink>

                    <template #popper>
                        {{ trans('menu.login') }}
                    </template>
                </Tooltip>
            </div>
        </div>
    </div>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { useUserStore} from "@/store/user";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import MenuIconItem from "@/components/menu/MenuIconItem.vue";
import { storeToRefs } from "pinia";
import Language from "@/components/Language.vue";
import { trans } from "@/libs/helper.js";
import { Tooltip } from "floating-vue";
import LogoImage from "@/components/LogoImage.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);
</script>
